import KvkkModal from '../components/KvkkModal';
import React, { useState } from 'react';
import axios from 'axios';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showKvkk, setShowKvkk] = useState(false);
  const [kvkkAccepted, setKvkkAccepted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Sayfa yüklenince token varsa temizle (geri tuşuyla gelindiyse)
  React.useEffect(() => {
    setLoading(false);
    setError(false);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError(false);
    try {
      const res = await axios.post('/api/auth/login', { username, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      window.location.replace(['admin','manager'].includes(res.data.user.role) ? '/yonetim' : '/panel');
    } catch {
      setError(true);
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

        * {
          box-sizing: border-box;
          font-family: 'Poppins', sans-serif;
          -webkit-font-smoothing: antialiased;
        }

        .login-wrapper {
          min-height: 100vh;
          background: #f1f5f9;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }

        .login-card {
          width: 100%;
          max-width: 960px;
          background: white;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 24px 80px rgba(0, 0, 0, 0.08);
          display: flex;
          flex-direction: row;
          min-height: 560px;
          animation: fadeSlideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1);
        }

        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Sol Panel Tasarımı */
        .left-panel {
          background: linear-gradient(145deg, #111827 0%, #1e1e2f 40%, #e30613 150%);
          padding: 60px 48px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;
          overflow: hidden;
          flex: 0 0 45%;
        }

        /* Arka plan süsleri (Circles) */
        .circle-decoration-1 {
          position: absolute;
          width: 450px;
          height: 450px;
          border-radius: 50%;
          border: 1px solid rgba(255, 255, 255, 0.05);
          top: -100px;
          right: -150px;
        }
        
        .circle-decoration-2 {
          position: absolute;
          width: 600px;
          height: 600px;
          border-radius: 50%;
          border: 1px solid rgba(255, 255, 255, 0.03);
          bottom: -250px;
          left: -200px;
        }

        .brand-container {
          z-index: 2;
          text-align: center;
        }

        .brand-logo {
          height: 65px;
          object-fit: contain;
          filter: brightness(0) invert(1);
          margin-bottom: 24px;
        }

        .brand-divider {
          width: 48px;
          height: 3px;
          background: #e30613;
          margin: 0 auto 20px;
          border-radius: 2px;
        }

        .brand-title {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.9);
          letter-spacing: 2.5px;
          text-transform: uppercase;
          font-weight: 300;
        }

        /* Sağ Panel Tasarımı */
        .right-panel {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 60px 56px;
          background: #ffffff;
        }

        .welcome-header {
          margin-bottom: 36px;
        }

        .welcome-title {
          font-size: 28px;
          font-weight: 800;
          color: #0f172a;
          margin: 0 0 8px;
          letter-spacing: -0.5px;
        }

        .welcome-subtitle {
          font-size: 14px;
          color: #64748b;
          margin: 0;
        }

        /* Form Elemanları */
        .form-group {
          margin-bottom: 20px;
        }
        
        .password-group {
          margin-bottom: 28px;
        }

        .form-label {
          display: block;
          margin-bottom: 8px;
          font-weight: 600;
          font-size: 12px;
          color: #475467;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .form-input {
          width: 100%;
          padding: 14px 16px;
          border: 1.5px solid #cbd5e1;
          border-radius: 12px;
          font-size: 14px;
          color: #1e293b;
          background: #f8fafc;
          transition: all 0.2s ease;
          outline: none;
        }

        .form-input::placeholder {
          color: #94a3b8;
        }

        .form-input:focus {
          border-color: #2563eb;
          background: #ffffff;
          box-shadow: 0 0 0 4px #eff6ff;
        }

        /* Parola Kutusu Özel Sınıfı (Hata Durumu İçin) */
        .form-input.error {
          border-color: #ef4444;
        }
        .form-input.error:focus {
          border-color: #ef4444;
          box-shadow: 0 0 0 4px #fef2f2;
        }

        .password-wrapper {
          position: relative;
        }

        .password-toggle-btn {
          position: absolute;
          right: 14px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          cursor: pointer;
          color: #94a3b8;
          padding: 0;
          display: flex;
          align-items: center;
          transition: color 0.2s;
        }

        .password-toggle-btn:hover {
          color: #475569;
        }

        .input-hint {
          font-size: 11px;
          color: #94a3b8;
          margin-top: 8px;
        }
        
        .input-hint strong {
          color: #64748b;
        }

        /* Hata Mesajı Animasyonlu */
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-6px); }
          40% { transform: translateX(6px); }
          60% { transform: translateX(-3px); }
          80% { transform: translateX(3px); }
        }

        .error-alert {
          background: #fef2f2;
          border: 1px solid #fecaca;
          border-radius: 12px;
          padding: 16px;
          margin-bottom: 24px;
          display: flex;
          align-items: flex-start;
          gap: 12px;
          animation: shake 0.4s ease;
        }

        .error-icon {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #ef4444;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .error-icon span {
          color: white;
          font-size: 14px;
          font-weight: 800;
        }

        .error-title {
          font-weight: 700;
          font-size: 13.5px;
          color: #b91c1c;
          margin-bottom: 4px;
        }

        .error-desc {
          font-size: 12.5px;
          color: #7f1d1d;
          line-height: 1.5;
        }

        /* Buton */
        .btn-submit {
          width: 100%;
          padding: 14px;
          background: #e30613;
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          letter-spacing: 0.5px;
          transition: all 0.2s ease;
          box-shadow: 0 4px 12px rgba(227, 6, 19, 0.25);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 8px;
        }

        .btn-submit:hover:not(:disabled) {
          background: #c2000c;
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(227, 6, 19, 0.35);
        }

        .btn-submit:disabled {
          background: #94a3b8;
          box-shadow: none;
          cursor: not-allowed;
          transform: none;
        }

        /* Footer Info */
        .login-footer {
          margin-top: 40px;
          padding-top: 24px;
          border-top: 1px solid #f1f5f9;
          text-align: center;
        }

        .login-footer p {
          font-size: 11.5px;
          color: #94a3b8;
          margin: 0;
          line-height: 1.6;
        }

        /* 📱 MOBİL UYUM (RESPONSIVE) - KAYDIRMAYI ÖNLER */
        @media (max-width: 768px) {
          .login-wrapper {
            padding: 16px;
          }
          
          .login-card {
            flex-direction: column;
            min-height: auto;
            border-radius: 20px;
          }

          .left-panel {
            padding: 24px 20px;
            flex: none;
          }

          .brand-logo {
            height: 42px;
            margin-bottom: 12px;
          }

          .brand-divider {
            margin-bottom: 12px;
          }
          
          .brand-title {
            font-size: 12px;
            letter-spacing: 1.5px;
          }

          .right-panel {
            padding: 24px 20px;
          }

          .welcome-header {
            margin-bottom: 20px;
          }

          .welcome-title {
            font-size: 22px;
            margin-bottom: 4px;
          }

          .form-group {
            margin-bottom: 16px;
          }
          
          .password-group {
            margin-bottom: 20px;
          }

          .form-input {
            padding: 12px 14px;
          }

          .btn-submit {
            padding: 12px;
            font-size: 14px;
            margin-top: 4px;
          }

          .login-footer {
            margin-top: 20px;
            padding-top: 16px;
          }
          
          .login-footer p {
            font-size: 10.5px;
          }
        }
      `}</style>

      <div className="login-card">
        
        {/* SOL PANEL (Marka Alanı) */}
        <div className="left-panel">
          <div className="circle-decoration-1" />
          <div className="circle-decoration-2" />
          
          <div className="brand-container">
            <img 
              src="/uploads/assets/logo.png" 
              alt="Petlas" 
              className="brand-logo"
              onError={e => { e.target.style.display='none'; }} 
            />
            <div className="brand-divider" />
            <div className="brand-title">Eğitim ve Akademi Portalı</div>
          </div>
        </div>

        {/* SAĞ PANEL (Form Alanı) */}
        <div className="right-panel">
          <div className="welcome-header">
            <h2 className="welcome-title">Hoş Geldiniz</h2>
            <p className="welcome-subtitle">Sisteme giriş yapmak için bilgilerinizi giriniz.</p>
          </div>

          {error && (
            <div className="error-alert">
              <div className="error-icon"><span>!</span></div>
              <div>
                <div className="error-title">Giriş Başarısız</div>
                <div className="error-desc">Sicil numaranız veya parolanız hatalı. Lütfen kontrol edip tekrar deneyin.</div>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">SİCİL NUMARASI</label>
              <input 
                value={username} 
                onChange={e => setUsername(e.target.value)} 
                required
                placeholder="Örn: 12345" 
                autoComplete="off"
                className={`form-input ${error ? 'error' : ''}`}
              />
            </div>

            <div className="password-group">
              <label className="form-label">PAROLA</label>
              <div className="password-wrapper">
                <input 
                  type={showPassword ? 'text' : 'password'} 
                  value={password} 
                  onChange={e => setPassword(e.target.value)} 
                  required
                  placeholder="Parolanızı girin (Pxxxxx)" 
                  autoComplete="current-password"
                  className={`form-input ${error ? 'error' : ''}`}
                  style={{ paddingRight: '48px' }}
                />
                <button 
                  type="button"
                  onMouseDown={() => setShowPassword(true)}
                  onMouseUp={() => setShowPassword(false)}
                  onMouseLeave={() => setShowPassword(false)}
                  onTouchStart={() => setShowPassword(true)}
                  onTouchEnd={() => setShowPassword(false)}
                  className="password-toggle-btn"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    {showPassword ? (
                      <><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></>
                    ) : (
                      <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>
                    )}
                  </svg>
                </button>
              </div>
              <div className="input-hint">
                Varsayılan parolanız: <strong>P + Sicil Numaranız</strong> (Örn: P12345)
              </div>
            </div>

            
            
            <button type="submit" disabled={loading} className="btn-submit">
              {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
            </button>
          </form>

          
          <div style={{ textAlign: 'center', marginTop: 14, marginBottom: 8 }}>
            <button
              type="button"
              onClick={() => setShowKvkk(true)}
              style={{
                background: 'none',
                border: 'none',
                color: '#64748b',
                fontSize: 12.5,
                textDecoration: 'underline',
                cursor: 'pointer',
                padding: '4px 8px'
              }}
              onMouseOver={e => e.currentTarget.style.color = '#0284c7'}
              onMouseOut={e => e.currentTarget.style.color = '#64748b'}
            >
              KVKK Aydınlatma Metni
            </button>
          </div>
          <KvkkModal
        isOpen={showKvkk}
        isMandatory={false}
        onClose={() => setShowKvkk(false)}
      />
          <div className="login-footer">
            <p>
              Petlas Eğitim ve Akademi Platformu<br />
              Bilgi ve yardım için Eğitim ve Akademi Şefliği ile iletişime geçebilirsiniz.<br />
              D: 1570 - 1573
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
